export default __webpack_public_path__ + "static/media/shopify-dark.68c05568.svg";